import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import MakeText from '../Components/Common/MakeText/MakeText';
import Logo from '../Components/Common/Logo';

export default () => (
	<View>
		<Logo />
		<MakeText style={styles.text}>Uw browser is verouderd. Om veiligheidsredenen vragen wij u uw browser te updaten voordat u gebruik kunt maken van onze website.</MakeText>
	</View>
);

const styles = StyleSheet.create({
	text: {
		color: '#414141',
		marginTop: 15,
	},
});
